module.exports = __webpack_public_path__ + "img/logo_circle_ws.d2540fa7.png";